export class StorageKeys {
    static readonly USERID = 'USERID';
  }